<template>
    <div>
        <div class="footer-wrapper">
            <div class="footer1">
                <div class="section"></div>
            </div>
            <div class="section"></div>
            <div class="cta11-form-wrap">
                <div id="w-node-82d999324993-c739f7eb" class="div-block-26">
                    <div class="cta11-title-wrap">
                        <div class="size3-text size3-top-clear">Questions?<br></div>
                        <p class="paragraph-71">Looking to support the cause but not sure how to contribute? Contact us with questions and details about your companies supply and manufacturing capabilities.</p>
                    </div>
                    <div>
                        <div class="cta11-item-wrap">
                            <div class="text-label">Email Us</div><a href="mailto:contact@rrpcanada.com" class="link">contact@rrpcanada.com</a></div>
                    </div>
                </div>
                <div id="w-node-82d9993249a5-c739f7eb" class="cta11-form w-form">
                    <form id="email-form" name="email-form" data-name="Email Form" class="cta11-form-wrap-copy">
                        <input type="email" class="text-field bottom-margin-field w-input" maxlength="256" name="email-3" data-name="Email 3" placeholder="Enter your name" id="email-2" required="">
                        <input type="email" class="text-field bottom-margin-field w-input" maxlength="256" name="email-3" data-name="Email 3" placeholder="Enter your email" id="email-3" required="">
                        <textarea placeholder="Enter your message" maxlength="5000" id="field-2" name="field-2" data-name="Field 2" class="text-area w-input"></textarea>
                        <input type="submit" value="Submit" data-wait="Please wait..." class="button-small form-centered-button w-button">
                    </form>
                    <div class="success-message w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div class="error-message w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContactUs",
    created () {
        document.title = "Contact Us";
    },
}
</script>

<style scoped>

</style>
